var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransportingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DCDEE1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 39.3336H30.0003M43.3337 39.3336H47.3337V35.1336C47.3346 34.8163 47.2223 34.509 47.017 34.2671C46.8117 34.0251 46.5269 33.8643 46.2137 33.8136L39.3337 32.6669L35.7337 27.8669C35.6095 27.7013 35.4484 27.5669 35.2633 27.4743C35.0781 27.3818 34.874 27.3336 34.667 27.3336H24.987C24.49 27.3301 24.002 27.4656 23.5779 27.7247C23.1538 27.9839 22.8106 28.3564 22.587 28.8002L21.5203 30.9736C20.9605 32.0864 20.6683 33.3145 20.667 34.5602V39.3336H23.3337M30.0003 40.0002C30.0003 41.8412 28.5079 43.3336 26.667 43.3336C24.826 43.3336 23.3337 41.8412 23.3337 40.0002C23.3337 38.1593 24.826 36.6669 26.667 36.6669C28.5079 36.6669 30.0003 38.1593 30.0003 40.0002ZM43.3337 40.0002C43.3337 41.8412 41.8413 43.3336 40.0003 43.3336C38.1594 43.3336 36.667 41.8412 36.667 40.0002C36.667 38.1593 38.1594 36.6669 40.0003 36.6669C41.8413 36.6669 43.3337 38.1593 43.3337 40.0002Z",
    stroke: "#E9353C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportingIcon);
export default __webpack_public_path__ + "static/media/transporting-icon.a027c928e82b52515837078dda83a33e.svg";
export { ForwardRef as ReactComponent };